import { render, staticRenderFns } from "./GratitudesJournal.vue?vue&type=template&id=6da33ffe&scoped=true&"
import script from "./GratitudesJournal.vue?vue&type=script&lang=js&"
export * from "./GratitudesJournal.vue?vue&type=script&lang=js&"
import style0 from "./GratitudesJournal.vue?vue&type=style&index=0&id=6da33ffe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da33ffe",
  null
  
)

export default component.exports